/* eslint-disable no-console */
/* eslint-disable no-use-before-define */

import React from 'react';
import ReactDOM from 'react-dom';

import DeveloperModal from 'components/developer_modal';

const GUSTO_ASCII_ART = `     _____ _    _  _____ _______ ____
    / ____| |  | |/ ____|__   __/ __ \\
   | |  __| |  | | (___    | | | |  | |
   | | |_ | |  | |\\___ \\   | | | |  | |
   | |__| | |__| |____) |  | | | |__| |
    \\_____|\\____/|_____/   |_|  \\____/`;

const PEEK_MESSAGE = `Ooh, you're good. Our app is built on awesome front end technologies such as React and Apollo.
  Wonder how we process billions of dollars in payroll? Well, first say "hello"!`;

// Step 1 - Peek through the window
function Peek() {
  console.log(PEEK_MESSAGE);
  window.say = say;
  patchConsoleLog();
}

// Step 2 - Say hello
function say() {
  console.log('How do you say things in console?');
}

const context = {
  hello() {
    fetch('/hello', { method: 'POST' }).then(() => {
      console.log('Psst. Check the headers :)');
      window.congrats = congrats;
    });
  },
};

let patched = false;
function patchConsoleLog() {
  if (patched) {
    return;
  }
  const consoleLog = console.log;
  console.log = (...args) => {
    if (args.length === 1 && context[args[0]]) {
      context[args[0]]();
    } else {
      consoleLog.apply(console, args);
    }
  };
  patched = true;
}

// Step 3 - Secret code
function congrats(code) {
  if (!code) {
    console.log('Say "hello" and follow the hints for a code.');
    return;
  }
  fetch(`/congrats?code=${code}`).then(response => {
    if (response.ok) {
      renderModal();
    } else {
      console.log('Oops, try again.');
    }
  });
}

function renderModal() {
  ReactDOM.render(
    React.createElement(DeveloperModal),
    document.getElementById('recruit-modal-mount'),
    () => {
      // BrandRefresh cleanup: Remove entire callback
      try {
        $('#recruit-modal').modal('show');
      } catch (e) {
        // Implies we're in BR, without bootstrap
      }
    }
  );
}

window.console = window.console || { log() {} };
window.Peek = Peek;

console.log(GUSTO_ASCII_ART);
console.log('Hello from Gusto! Curious about how we work?');
console.log('"Peek" through the "window" to find out.');
